import { render, staticRenderFns } from "./userinfo-service.vue?vue&type=template&id=3c32fcbc&"
import script from "./userinfo-service.vue?vue&type=script&lang=js&"
export * from "./userinfo-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports